module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "fade"
    },
    on: {
      "after-enter": _vm.afterEnter
    }
  }, [_c('div', {
    ref: "popup",
    staticClass: "popup",
    staticStyle: {
      "background-image": "url('static/img/main/point2/popup/bg.png')"
    }
  }, [_c('div', {
    staticClass: "popup-bg delay3"
  }), _vm._v(" "), _c('div', {
    staticClass: "popup-inner "
  }, [_c('a', {
    staticClass: "close",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closePopup($event)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "left delay6"
  }, [_c('div', {
    staticClass: "quotes quotes-right"
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("\n                    Все мои поездки в эту страну были связаны со сноубордингом, тренировками в горах и наслаждением природой\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('span', {
    staticClass: "point"
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("\n                        Базель, Швейцария\n                    ")])]), _vm._v(" "), _c('h3', {
    staticClass: "head"
  }, [_vm._v("\n                        Базель — историческая "), _c('br'), _vm._v("\n                        родина Weleda\n                    ")]), _vm._v(" "), _c('span', {
    staticClass: "desc"
  }, [_vm._v("\n                       Сегодня Базель не сходит с газетных полос: в городе, расположенном между изумрудными вершинами Юры и Шварцвальда, три дюжины музеев, первоклассный музыкальный театр, сияющие штаб-квартиры крупнейших банков. Но чуть меньше ста лет назад Базель давал газетам совсем другие инфоповоды: в начале 1920-х в базельском пригороде Арлесхайм открылась первая в мире клиника антропософской медицины, основанная тремя энтузиастами — врачом, философом и фармацевтом. Главный принцип антропософской медицины — правильно стимулировать организм, чтобы тот сам боролся с болезнью, — близок взглядам Weleda, компании, которая выросла из маленькой лаборатории при арлесхаймской клинике.\n                ")])])]), _vm._v(" "), _c('div', {
    staticClass: "right delay9"
  }, [_c('div', {
    staticClass: "popup-products"
  }, [_c('div', {
    staticClass: "info"
  }, [_c('h4', {
    staticClass: "head"
  }, [_vm._v("\n                            Натуральные ингредиенты\n                        ")]), _vm._v(" "), _c('span', {
    staticClass: "desc"
  }, [_vm._v("\n                            Для сохранения природной силы около 1000 натуральных ингредиентов сотрудники Weleda собирают растения быстро и минимально обрабатывают их: только таким образом вещества и активные компоненты раскрывают и сохраняют свои ценные качества.\n                        ")]), _vm._v(" "), _c('a', {
    staticClass: "btn",
    attrs: {
      "href": "https://www.weleda.ru/%D0%BA%D1%80%D0%B0%D1%81%D0%BE%D1%82%D0%B0-%D0%BE%D1%82-%D0%BF%D1%80%D0%B8%D1%80%D0%BE%D0%B4%D1%8B/%D0%BD%D0%B0%D1%82%D1%83%D1%80%D0%B0%D0%BB%D1%8C%D0%BD%D0%B0%D1%8F-%D0%BA%D0%BE%D1%81%D0%BC%D0%B5%D1%82%D0%B8%D0%BA%D0%B0-weleda?utm_source=afisha&utm_medium=card&utm_term=switzerland&utm_content=natural_cosmetics&utm_campaign=weleda_afisha_sp_summer_2018",
      "target": "_blank"
    },
    on: {
      "click": function($event) {
        _vm.gaEvents('places', 'click', 'know more ')
      }
    }
  }, [_vm._v("\n                            Подробнее\n                        ")])]), _vm._v(" "), _c('div', {
    staticClass: "img popup-products-img2 "
  }, [_c('img', {
    attrs: {
      "src": "static/img/main/point2/popup/product.png",
      "alt": ""
    }
  })])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e483c6c6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/popups/popup2.vue
// module id = 551
// module chunks = 1